import { GET_ADDITIONAL_SERVICES_AND_TARIFF } from '../actions/actionTypes';

import AddServicesTariff from '../../models/AddServicesTariff';

const initialState: AddServicesTariff = {
    breakdown_hawb: {
        cost_per_kg_usd: 0
    },
    bup_ld3: {
        cost_usd: 0
    },
    bup_ld7: {
        cost_usd: 0
    },
    bup_main_deck: {
        cost_usd: 0
    },
    bup_20ft: { cost_usd: 0 },
    bup_q7: { cost_usd: 0 },
    label_freight: { cost_per_box_usd: 0 },
    import_service: {
        cost_usd: 0
    },
    return_fee: {
        cost_usd: 0
    },
    per_hawb: {
        cost_per_hawb_usd: 0
    },
    per_hawb_exclude_import_service: {
        cost_per_hawb_usd: 0
    },
    reicing: {
        cost_per_kg_usd: 0
    },
    perishable_storage: {cost_per_day_min_usd: 0, cost_per_kg_per_day_usd: 0},
    cage_vault: {cost_per_day_min_usd: 0, cost_per_kg_per_day_usd: 0},
    storage_fee: { 
        free_days: 0, min_cost_usd: 0, storage_divisor: 0, first_weekend_free: false, arrival_day_counted: false, 
        all_public_holidays_counted: false, first_public_holiday_counted: false, cost_per_storage_unit_per_day_usd: 0
    },
    customs_fee: {
        ces_handling_fee: 0, min_cost_usd: 0, in_bond_fee: 0,
        us_customs_fee: 0, processing_fee: 0, transportation_fee: 0
    },
    other: {},
    gha_adjust: {},
    skid_exch: {
        cost_usd: 0
    },
    comat: {},
    copa_comat: {},
    nomination_fee: {},
    certified_manifest_charge: { cost_usd: 0 }
};

export default function addServiceTariffReducer(state: AddServicesTariff = initialState, action: any) {

  switch (action.type) {

    case GET_ADDITIONAL_SERVICES_AND_TARIFF:
      let result: AddServicesTariff = {...action.data};
      return result;

    default: return state;
  }

};
